import React from 'react'
import { Col, Row } from 'reactstrap'
import PropTypes from 'prop-types'

const propTypes = {
  commFavs: PropTypes.array
}

const CommFavPlaceholder = ({ commFavs }) => (
  <Row>
    {
      commFavs.map((commFav, index) => (
        <Col
          key={ `comm-fav-placeholder-${commFav.id}` }
          sm={ 2 }
          className='p-2 text-center'
        >
          <img
            src={ commFav.image }
            style={{ width: 'auto', height: '100px' }}
          />
          <div>
            { index+1 }{ '. ' }{ commFav.label }
          </div>
        </Col>
      ))
    }
  </Row>
)

CommFavPlaceholder.propTypes = propTypes

export default CommFavPlaceholder